var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('LoadingContainer',[_c('ProgressBarMe'),_c('ProgressBarAppointments'),_c('ProgressBarMeetings')],1):_c('CalendarFrame',{attrs:{"event":_vm.event,"items":_vm.allAnnotated,"timezone":_vm.timezone,"me":_vm.me,"slots":_vm.slotsAnnotated,"tracks":_vm.tracks}})
}
var staticRenderFns = []

export { render, staticRenderFns }